
import {
    ADD_DOCUMENT_FOR_OBJECT,
    CLEAR,
    DATA_DOCUMENT_ACTION_TYPE,
    REMOVE_DOCUMENT_FOR_OBJECT,
    SET_DOCUMENTS_FOR_OBJECT,
    UPDATE_DOCUMENT_FOR_OBJECT
} from '../sagas/document';

const initialState = {
    loading: false,
    documentObjectCache: {}
};

export function calculateObjectKeyForDocument(object, attachedDocuments) {
    return (object && attachedDocuments)
        ? `${object.layerId}_${object.attributes[attachedDocuments.key]}`
        : `NULL_OBJECT`;
}

export function getDocumentList(state, objectKey) {
    return state.documentObjectCache[objectKey];
}

export function isLoading(state) {
    return state.loading;
}

function addDocumentForObject(state, action) {
    return {
        ...state,
        documentObjectCache: {
            ...state.documentObjectCache,
            [action.document.object_key]: [
                ...state.documentObjectCache[action.document.object_key],
                action.document
            ]
        }
    };
}

function clear(state, action) {
    return {
        ...state,
        documentObjectCache: {}
    };
}

function removeDocumentForObject(state, action) {
    return {
        ...state,
        documentObjectCache: {
            ...state.documentObjectCache,
            [action.document.object_key]: state.documentObjectCache[action.document.object_key].filter(item => {
                return (item.gid !== action.document.gid);
            })
        }
    };
}

function setDocumentsForObject(state, action) {
    return {
        ...state,
        documentObjectCache: {
            ...state.documentObjectCache,
            [action.objectKey]: action.documents
        }
    };
}

function updateDocumentForObject(state, action) {
    return {
        ...state,
        documentObjectCache: {
            ...state.documentObjectCache,
            [action.document.object_key]: state.documentObjectCache[action.document.object_key].map(item => {
                return (item.gid === action.document.gid)
                    ? action.document
                    : item;
            })
        }
    };
}

function document(state = initialState, action) {
    switch (action.type) {

        case DATA_DOCUMENT_ACTION_TYPE.LOADING:
            return {
                ...state,
                loading: true
            };

        case DATA_DOCUMENT_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                loading: false
            };

        case DATA_DOCUMENT_ACTION_TYPE.FAILED:
            return {
                ...state,
                loading: false
            };

        case CLEAR:
            return clear(state, action);

        case ADD_DOCUMENT_FOR_OBJECT:
            return addDocumentForObject(state, action);

        case REMOVE_DOCUMENT_FOR_OBJECT:
            return removeDocumentForObject(state, action);

        case SET_DOCUMENTS_FOR_OBJECT:
            return setDocumentsForObject(state, action);

        case UPDATE_DOCUMENT_FOR_OBJECT:
            return updateDocumentForObject(state, action);

        default:
            return state;
    }
}

export default document;
